import { useHistory, useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { manaFiatGatewayPurchaseCompleted } from '../modules/gateway';
export default function useManaFiatGatewayPurchase() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const network = query.get('network');
    const gateway = query.get('gateway');
    const transactionId = query.get('transactionId');
    const transactionStatus = query.get('transactionStatus');
    const history = useHistory();
    const dispatch = useDispatch();
    if (transactionId && transactionStatus && network && gateway) {
        const queryParams = new URLSearchParams(query);
        const params = ['transactionId', 'transactionStatus', 'network', 'gateway'];
        params.forEach(param => queryParams.delete(param));
        history.replace(`${location.pathname}?${queryParams.toString()}`);
        dispatch(manaFiatGatewayPurchaseCompleted(network, gateway, transactionId, transactionStatus));
    }
}
//# sourceMappingURL=useManaFiatGatewayPurchase.js.map